export type GraphicsMode='classic'|'modern';
export type GraphicsQuality='auto'|'low'|'medium'|'high';
export type LightingMood='day'|'night';
export interface GraphicsSettings {
  graphicsMode:GraphicsMode; graphicsQuality:GraphicsQuality; lightingMood:LightingMood;
  cameraEffects:boolean; batterySaver:boolean;visualEffects:boolean;collisionDebug:boolean;
}
export const GRAPHICS_DEFAULTS:GraphicsSettings={graphicsMode:'classic',graphicsQuality:'auto',lightingMood:'day',cameraEffects:true,batterySaver:false,visualEffects:true,collisionDebug:false};
export function graphicsSettings(value:Partial<GraphicsSettings>):GraphicsSettings{
  return {graphicsMode:value.graphicsMode==='modern'?'modern':'classic',
    graphicsQuality:['low','medium','high'].includes(value.graphicsQuality||'')?value.graphicsQuality as GraphicsQuality:'auto',
    lightingMood:value.lightingMood==='night'?'night':'day',cameraEffects:value.cameraEffects!==false,batterySaver:value.batterySaver===true,visualEffects:value.visualEffects!==false,collisionDebug:value.collisionDebug===true};
}
